import { RESTAURANT_CATERING_READ, RESTAURANT_CATERING_WRITE } from 'scopes/scopes';
import { useHasLocationScope } from './useHasLocationScope';

export const useHasCateringScope = (): boolean => {
  const hasRead = useHasLocationScope(RESTAURANT_CATERING_READ);
  const hasWrite = useHasLocationScope(RESTAURANT_CATERING_WRITE);

  return hasRead && hasWrite;
};

export const useHasCateringReadOnlyScope = (): boolean => {
  const hasRead = useHasLocationScope(RESTAURANT_CATERING_READ);
  const hasWrite = useHasLocationScope(RESTAURANT_CATERING_WRITE);

  return hasRead && !hasWrite;
};
